import React, { createContext, useState } from "react";
import {
  MuiThemeProvider,
  CssBaseline,
  createMuiTheme,
} from "@material-ui/core";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

import CacheBuster from "../components/common/CacheBuster";
import Login from "../components/pages/Login";
import Logout from "../components/pages/Logout";
import Forgot from "../components/pages/Forgot";
import PrivateRoute from "../auth/PrivateRoute";
import Calendar from "../components/pages/Calendar";
import List from "../components/pages/List";
import Detail from "../components/pages/Detail";
import Input from "../components/pages/Input";
import PassChange from "../components/pages/PassChange";
import MailChange from "../components/pages/MailChange";
import Notification from "../components/pages/Notification";

// iOS/Safariで「minHeight:100vh」が正常動作しない不具合対応
import viewportUnit from "viewport-units-buggyfill";

viewportUnit.init({ force: true });

export const BadgeContext = createContext();

export default function App() {
  // 独自のテーマを設定
  const theme = createMuiTheme({
    typography: {
      fontSize: 21, // 全体のフォントサイズを大きく変更(16->21)
      button: {
        textTransform: "none", // Buttonが自動で大文字になることを防ぐ
      },
    },
  });

  const publicRoutes = [
    { path: "/login", Component: Login },
    { path: "/logout", Component: Logout },
    { path: "/forgot", Component: Forgot },
  ];

  const privateRoutes = [
    { path: "/calendar", Component: Calendar },
    { path: "/list", Component: List },
    { path: "/detail", Component: Detail },
    { path: "/input", Component: Input },
    { path: "/passchange", Component: PassChange },
    { path: "/mailchange", Component: MailChange },
    { path: "/notification", Component: Notification },
  ];

  // TODO:バッヂ表示機能は後ほど実装する
  // 本番では初期値をAPIやLocalStorage等からとる
  const [isShowBadge, setIsShowBadge] = useState(false);

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {/* 下のonClick()はダブルタップによるズームの抑止用 */}
      <div className="app" onClick={(e) => {}}>
        <BrowserRouter>
          <CacheBuster />

          <BadgeContext.Provider value={{ isShowBadge, setIsShowBadge }}>
            <Switch>
              {publicRoutes.map((publicRoute, idx) => (
                <Route
                  exact
                  path={publicRoute.path}
                  render={(props) => <publicRoute.Component {...props} />}
                  key={idx}
                />
              ))}

              {privateRoutes.map((privateRoute, idx) => (
                <PrivateRoute
                  exact
                  path={privateRoute.path}
                  render={(props) => <privateRoute.Component {...props} />}
                  key={idx}
                />
              ))}

              <Redirect from="/" to="/calendar" />
            </Switch>
          </BadgeContext.Provider>
        </BrowserRouter>
      </div>
    </MuiThemeProvider>
  );
}
